<template>
	<div class="actlistdetail">
		<div class="topcon">
			<div class="carcon">
				<div is='titlebox' :nav='JSON.parse(nav)' ></div>
			</div>
		</div>

		<div class="listcon">
			<div class="list">
				<div class="list_a">
					<div class="l_c">
						<div class="signle">
							<div class="imgcon">
								<img :src="$util.imgSrc(info.coverMap)" />
							</div>

							<div class="informcon">
								<div class="title overf-elli" :title="info.name">{{info.name?info.name:''}}</div>
								<div class="other">
									<div class="l_c">
										<!-- <img src="../../assets/img/position@2x.png" />
										<div>大海区</div>
										<div class="line"></div> -->
										<div>已报名{{info.isNumber?info.isNumber:0}}人</div>
									</div>
									<div class="r_c">报名截止：{{info.deadline|getval}}</div>
								</div>
							</div>

						</div>

					</div>
					<div class="r_c">
						<div class="title">活动信息</div>
						<div class="tip"><div class="name">活动地点</div>
							<span>{{info.address?info.address:''}}</span>
						</div>
						<div class="tip"><div class="name">活动时间</div>
							<span>{{info.startTime?info.startTime.split(' ')[0]:''}}-{{info.endTime?info.endTime.split(' ')[0]:''}}</span>
						</div>
						<div class="tip"><div class="name">负责人</div>
							<span>{{info.principal?info.principal:''}}</span>
						</div>
						<div class="tip"><div class="name">联系方式</div>
							<span>{{info.principalPhone?info.principalPhone:''}}</span>
						</div>
					</div>

				</div>

				<div class="informcar">
					<div class="title">活动详情</div>
					<div class="msg" v-html="info.content"></div>
				</div>

			</div>
		</div>


	</div>

</template>

<script>

import dataFn from '../../utils/date.js';
export default {
	filters:{
	  getval(val){
		  var time='';
		 if(val){
			 time=dataFn.GetNumberOfDays(dataFn.date, val,1);
		 }
		if(time.indexOf('-')!=-1){
			return '已截止'
		}
		return time
	  }
  },
  computed:{
      nav:function(){
          var arr=[
  			    {
  			    	label:'引领示范活动',
  			    	path:'/jumppage/actlist',
  			    	type:0
  			    },
  				{
  					label:'志愿青春',
  					path:'/jumppage/actlistdetail',
  					type:0
  				}
  			]
  			return JSON.stringify(arr)
      }
  },
  data: function() {
		return {
			msg:"为了助力全市创建全国文明典范城市，青海省发动全国党员干部、鄞州区三八红旗手联盟、巾帼志愿者、各类特色家庭成员，开展志愿服务活动，希望搭建踊跃参与。为了进一步推动“五城同创”，改善青海省容市貌，创造一个幸福宜居的环境，",
			info:{}

		};
  },

  created() {
	this.getInfo()
  },

  methods: {
	getInfo(){
		this.$axios.get(this.$apiUrlZY+`api/external/queryById?id=${this.$route.query.id}`).then(res=>{
			if(res.success){
				this.info=res.result
			}
		})
	}
  },


};
</script>

<style scoped="scoped" lang="scss">

.actlistdetail{
	// width: 1200px;
	position: relative;
	left: 50%;
	transform: translateX(-50%);
	height: 100%;
	background: #ffffff;

	.topcon{
		display: flex;
		justify-content: center;
		.carcon{
			width: 1260px;
		}
	}

	.listcon{
		display: flex;
		justify-content: center;
		.list{
			width: 1200px;
			display: flex;
			flex-direction: column;
			.list_a{
				display: flex;
				.l_c{
					flex: 1;
					.signle{
						// cursor: pointer;
						margin-top: 50px;
						margin-left: 20px;
						width: 570px;
						height: 340px;
						background: #FFFFFF;
						border: 1px solid #E0E0E0;
						border-radius: 5px;
						.imgcon{
							height: 221px;
							img{
								width: 100%;
								height: 221px;
							}
						}
						.informcon{
							padding: 20px;
							.title{
								height: 50px;
								line-height: 50px;
								font-size: 16px;
								font-weight: 400;
								color: #333333;
							}
							.other{
								display: flex;
								justify-content: space-between;
								.l_c{
									display: flex;
									align-items: center;
									font-size: 14px;
									font-weight: 400;
									color: #666666;
									img{
										height: 20px;
										width: 18px;
										margin-right: 10px;
									}
									.line{
										margin-left: 10px;
										margin-right: 10px;
										height: 16px;
										border: 1px solid #999999;
									}
								}
								.r_c{
									font-size: 14px;
									font-weight: 400;
									color: #666666
								}
							}
						}
					}

				}
				.r_c{
					flex: 1;
					display: flex;
					flex-direction: column;
					justify-content: center;
					margin-left: 40px;
					.title{
						font-size: 24px;
						font-weight: 500;
						color: #333333;
						height: 100px;
						line-height: 100px;
					}
					.tip{
						font-size: 16px;
						font-weight: 400;
						color: #333333;
						height: 50px;
						line-height: 50px;
						display: flex;
						.name{
							width: 100px;
							font-size: 16px;
							font-weight: 400;
							color: #999999;
						}

					}
				}
			}


			.informcar{
				margin-top: 40px;
				margin-left: 20px;
				.title{
					font-size: 24px;
					color: #333333;
				}
				.msg{
					margin-top: 40px;
					margin-bottom: 40px;
				}
			}


		}

	}




}

</style>
